import Vue from 'vue';
import Component from 'vue-class-component';


@Component({

})
export default class Modal extends Vue{
isOpen:boolean=false;

openModal(){
this.isOpen=true;
}

closeModal(){
    this.isOpen=false;
}

}